import * as React from "react";
import "./Style.css";
import { Tooltip } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Button from "@mui/material/Button";
import StyledMenuInput from "../../StyledMenu/Index";
import moment from "moment";
import { getConfidenceScore } from "../../../Utils/Utils";
export default function CompanyProfile({
  dataForInformation,
  handleToPDF,
  setIsDecisionMakerExcel,
  setIsSalesForceTrigger,
  setArchiveRecord,
  setTrackRecord,
  setRequestUpdateRecord,
  disableRequestUpdate,
  setShareRecord,
  value,
  showSalesForce,
  overviewPdfModal,
  handleOrganizationPdf,
  handleShowPdfModal,
  handleClosePdfModal,
  anchorEl,
  setAnchorEl,
  downloadSingleTab,
  downloadMultipleTab,
  setAddToFavorite,
  handleCheckbox,
  disableTracking,
  handleTrackingdata,
}) {
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuSalesforce = () => {
    setIsSalesForceTrigger(true);
    setAnchorEl(null);
  };
  const handleMenuDownloadExcel = () => {
    setIsDecisionMakerExcel(true);
    setAnchorEl(null);
  };
  const handleAnchoElement = () => {
    setAnchorEl(null);
  };
  const handleMenuArchiveRecord = () => {
    setArchiveRecord(true);
    setAnchorEl(null);
  };
  const handleMenuTrackRecord = () => {
    setTrackRecord(true);
    setAnchorEl(null);
  };
  const handleMenuAddToFavorite = () => {
    setAddToFavorite(true);
    setAnchorEl(null);
  };
  const handleMenuShareRecord = () => {
    setShareRecord(true);
    setAnchorEl(null);
  };
  const handleMenuRequestUpdateRecord = () => {
    setRequestUpdateRecord(true);
    setAnchorEl(null);
  };
  const handleToPDFClick = () => {
    handleToPDF();
    setAnchorEl(null);
  };
  return (
    <>
      <div
        className={"Leades-filter-drop-down-button-main-container-org do_not_print"}
      >
        <div className="org-heading-dropdowns">
          {window?.location.pathname.includes("companyprofilescreen") && (
                <div>
                  <h3>Organization Details</h3>

                </div>
          )}
            <div className="Leades-filter-inner-container">
              <Button
                id="action-button"
                aria-controls={open ? "action-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                variant="contained"
                disableElevation
                onClick={handleMenuClick}
                endIcon={<KeyboardArrowDownIcon />}
              >
                Action
              </Button>
              <StyledMenuInput
                disableTracking={disableTracking}
                handleShowPdfModal={handleShowPdfModal}
                showSalesForce={showSalesForce}
                handleToPDF={handleToPDFClick}
                anchorEl={anchorEl}
                open={open}
                handleAnchoElement={handleAnchoElement}
                handleMenuSalesforce={handleMenuSalesforce}
                handleMenuDownloadExcel={handleMenuDownloadExcel}
                handleMenuArchiveRecord={handleMenuArchiveRecord}
                handleMenuTrackRecord={handleMenuTrackRecord}
                handleMenuAddToFavorite={handleMenuAddToFavorite}
                handleMenuRequestUpdateRecord={handleMenuRequestUpdateRecord}
                disableRequestUpdate={disableRequestUpdate}
                handleMenuShareRecord={handleMenuShareRecord}
              />
            </div>
           
        </div>
      <div className="data-sync-c-rate-org">
        <div className="datasync-line-c-score">
          <span className="datasync-line">Data Sync: </span>{" "}
          <span className="datasync-line-data">
            {dataForInformation?.updated_at
              ? moment(dataForInformation.updated_at).format("MM.DD.YY")
              : "No update information available"}
          </span>{" "}
        </div>
        <div className="datasync-line-c-score">
          <Tooltip
            title={
              "This score reflects a combination of record completeness, freshness, and data source reliability."
            }
          >
            <span>
              <span className="datasync-line">Data Confidence Score:</span>
              <span className="datasync-line-data">
                {dataForInformation?.confidence_score
                  ? getConfidenceScore(dataForInformation.confidence_score)
                  : "No update information available"}
              </span>
            </span>
          </Tooltip>
        </div>
      </div>
      </div>

     

    </>
  );
}
